module.exports = __webpack_public_path__ + "static/img/star-active@2x.7cddcfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/star-active@2x.png
// module id = BEao
// module chunks = 1